import styled from 'styled-components'

import { AVATAR_SIZES, type AvatarSize } from '../constants/avatarSizes'

export interface IAvatarInitialsStyledProps {
  $size: AvatarSize
}

export const AvatarInitialsStyled = styled.span<IAvatarInitialsStyledProps>`
  font-size: ${(props) =>
    props.theme.typography.pxToRem(
      props.theme.fontSizes[AVATAR_SIZES[props.$size].fontSizeToken]
    )};
  line-height: ${(props) =>
    props.theme.typography.pxToRem(AVATAR_SIZES[props.$size].lineHeightPx)};
  font-weight: ${(props) =>
    props.theme.fontWeights[AVATAR_SIZES[props.$size].fontWeightToken]};
`

AvatarInitialsStyled.displayName = 'AvatarInitialsStyled'
